var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBearLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 132.29 132.29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -164.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.439 272.66c-6.7448 4.9216-20.887 15.883-29.232 16.153-7.6295 0.24652-20.773-9.8644-26.958-14.338-6.765-4.8938-21.56-14.956-24.396-22.81-2.5921-7.1799 2.9624-22.804 5.3063-30.069 2.5638-7.9462 7.5617-25.127 14.155-30.25 6.0275-4.6839 22.604-4.2296 30.237-4.2453 8.3495-0.0172 26.234-0.57301 33.144 4.114 6.3173 4.285 11.008 20.19 13.381 27.445 2.5965 7.9356 8.6517 24.773 6.3293 32.793-2.1232 7.3322-15.801 16.708-21.967 21.207z",
    fill: "#5e2750",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2c001e"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.43931 0 0 -.44406 40.241 149.12)",
    d: "m89.255-181.57c-6.7448 4.9216-20.887 15.883-29.232 16.153-7.6295 0.24651-20.773-9.8644-26.958-14.338-6.765-4.8938-21.56-14.956-24.396-22.81-2.5921-7.1799 2.9624-22.804 5.3063-30.069 2.5638-7.9462 7.5617-25.127 14.155-30.25 6.0275-4.6839 22.604-4.2296 30.237-4.2453 8.3495-0.0172 26.234-0.57302 33.144 4.114 6.3173 4.285 11.008 20.19 13.381 27.445 2.5965 7.9356 8.6517 24.773 6.3293 32.793-2.1232 7.3322-15.801 16.708-21.967 21.207z",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93763 -.34762 -.36309 -.93175 0 0)",
    d: "m-24.716-187.76a12.501 12.27 0 0 1-8.1095 11.488 12.501 12.27 0 0 1-13.807-3.4167 12.501 12.27 0 0 1-1.5914-13.889",
    strokeWidth: 0.32769
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.93763 -.34762 .36309 -.93175 0 0)",
    d: "m-149.44-141.22a12.501 12.27 0 0 1-8.1095 11.488 12.501 12.27 0 0 1-13.807-3.4167 12.501 12.27 0 0 1-1.5914-13.889",
    strokeWidth: 0.32769
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.55764 .39392 -.36797 .58555 123.13 48.164)",
    d: "m114.66 204.79c-0.79676 0.35854-3.8792-1.8052-4.5881-2.3159-0.70889-0.51074-3.7371-2.7497-3.6493-3.619 0.0879-0.86928 3.5029-2.4569 4.2997-2.8155s4.2499-1.8616 4.9588-1.3508c0.70888 0.51074 0.3763 4.2621 0.28842 5.1314-0.0879 0.86928-0.51277 4.6113-1.3095 4.9699z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.55764 .39392 -.36797 .58555 126.17 55.698)",
    d: "m114.66 204.79c-0.79676 0.35854-3.8792-1.8052-4.5881-2.3159-0.70889-0.51074-3.7371-2.7497-3.6493-3.619 0.0879-0.86928 3.5029-2.4569 4.2997-2.8155s4.2499-1.8616 4.9588-1.3508c0.70888 0.51074 0.3763 4.2621 0.28842 5.1314-0.0879 0.86928-0.51277 4.6113-1.3095 4.9699z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.55764 .39392 .36797 .58555 11.266 48.211)",
    d: "m114.66 204.79c-0.79676 0.35854-3.8792-1.8052-4.5881-2.3159-0.70889-0.51074-3.7371-2.7497-3.6493-3.619 0.0879-0.86928 3.5029-2.4569 4.2997-2.8155s4.2499-1.8616 4.9588-1.3508c0.70888 0.51074 0.3763 4.2621 0.28842 5.1314-0.0879 0.86928-0.51277 4.6113-1.3095 4.9699z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.55764 .39392 .36797 .58555 8.2199 55.744)",
    d: "m114.66 204.79c-0.79676 0.35854-3.8792-1.8052-4.5881-2.3159-0.70889-0.51074-3.7371-2.7497-3.6493-3.619 0.0879-0.86928 3.5029-2.4569 4.2997-2.8155s4.2499-1.8616 4.9588-1.3508c0.70888 0.51074 0.3763 4.2621 0.28842 5.1314-0.0879 0.86928-0.51277 4.6113-1.3095 4.9699z"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.93763 -.34762 .36309 -.93175 0 0)",
    d: "m-162.26-178.68a12.501 12.27 0 0 1-6.2506 10.627 12.501 12.27 0 0 1-12.501 0 12.501 12.27 0 0 1-6.2506-10.627h12.501z",
    fillOpacity: 0,
    strokeWidth: 0.32769
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2c001e"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79896 0 0 .86844 8.741 32.466)",
    d: "m60.804 198.15c1.8899 3.3073 1.8514 11.946-0.06784 15.237-1.9193 3.2903-9.42 7.5765-13.229 7.5595-3.8091-0.017-11.271-4.3697-13.161-7.677s-1.8514-11.946 0.06784-15.237c1.9193-3.2903 9.42-7.5765 13.229-7.5595 3.8091 0.017 11.271 4.3697 13.161 7.677z",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79896 0 0 .8509 21.536 35.807)",
    d: "m95.2 198.14c1.8899 3.3073 1.8514 11.946-0.06784 15.237-1.9193 3.2903-9.42 7.5765-13.229 7.5595-3.8091-0.017-11.271-4.3697-13.161-7.677s-1.8514-11.946 0.06784-15.237c1.9193-3.2903 9.42-7.5765 13.229-7.5595 3.8091 0.017 11.271 4.3697 13.161 7.677z",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.95354 .30127 .31701 .94842 0 0)",
    d: "m33.753 280.33a12.501 12.27 0 0 1-6.2506 10.627 12.501 12.27 0 0 1-12.501 0 12.501 12.27 0 0 1-6.2506-10.627h12.501z",
    strokeWidth: 0.32769
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearLogo);
export default __webpack_public_path__ + "static/media/bearLogo.59cdc21585ee3db0de5bc98a57cc69e0.svg";
export { ForwardRef as ReactComponent };